<!--
 * @Author: yaoyuting
 * @Date: 2021-04-11 18:24:56
 * @LastEditors: yaoyuting
 * @LastEditTime: 2021-05-19 19:49:54
 * @Descripttion:
-->
<template>
    <div class="Blog">
        <div class="title">
            <div class="BigTitle">{{ $t("Fund.title") }}</div>
            <div class="SubTitle">{{ $t("Fund.what") }}</div>
            <div class="detail">{{ $t("Fund.detail") }}</div>
            <div class="build">
                {{ $t("Fund.build") }}
                <img src="../../../assets/m/index/Union.png">
            </div>
        </div>
        <div class="box-card">
            <div class="item">
                <div class="hover-item" @click="goToWiki">
                    <img src="../../../assets/m/intro/View.png"/>
                    <div class="introT">{{ $t("Fund.wiki") }}</div>
                    <div class="introD">{{ $t("Fund.learnMore") }}</div>
                </div>
            </div>
            <div class="item">
                <div class="hover-item" @click="buildPage">
                    <img src="../../../assets/m/intro/Deploy.png"/>
                    <div class="introT">{{ $t("Fund.deploy") }}</div>
                    <div class="introD">{{ $t("Fund.deploySteps") }}</div>
                </div>
            </div>
            <div class="item">
                <div class="hover-item" @click="buildPage">
                    <img src="../../../assets/m/intro/Interface.png"/>
                    <div class="introT">{{ $t("Fund.api") }}</div>
                    <div class="introD">{{ $t("Fund.apiMore") }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  data() {
    return {

    };
  },
  mounted() {
    this.init();
  },
  destroyed() {
  },
  methods: {
    goToWiki() {
      window.location.href="https://www.donetwork.io/doc/";
    },
    buildPage() {
      this.$message({
        message: 'In Building...',
        type:'warning'
      })
    }
  },
};
</script>

<style lang="less" scoped>
    .Blog {
        text-align: center;
        margin-bottom: 157px;
        width: 100%;
        color: #000000;
        .title {
            text-align: center;
            /*height: 761px;*/
            background: url("../../../assets/m/intro/bgi.png") no-repeat center/100%
            100%;
            .BigTitle {
                padding-top: 230px;
                width: 648px;
                font-size: 64px;
                font-weight: 900;
                color: #000000;
                font-family: Poppins-Black, Poppins;
                line-height: 83px;
                margin: 0 auto;
                padding-bottom: 20px;
            }
            .SubTitle {
                font-size: 30px;
                font-weight: 500;
                font-family: Poppins-Medium, Poppins;
                color: #000000;
                line-height: 35px;
                padding-bottom: 20px;
            }
            .detail {
                width: 645px;
                font-size: 26px;
                font-weight: 500;
                color: #61666B;
                font-family: Poppins-Medium, Poppins;
                line-height: 43px;
                margin: 0 auto;
                padding-bottom: 100px;
            }
            .build{
                margin: 0 auto;
                font-size: 30px;
                font-weight: 600;
                color: #FFFFFF;
                line-height: 133px;
                font-family: Poppins-SemiBold, Poppins;
                text-shadow: 0px 3px 7px #3667E1;
                padding-left: 41px;
                text-align: left;
                background: url("../../../assets/m/index/rectbg.png") no-repeat center/100%
                100%;
                width: 650px;
                height: 133px;
                /*background: linear-gradient(270deg, #4573E7 0%, rgba(69, 115, 231, 0.8) 100%);*/
                box-shadow: 0px 21px 41px 1px rgba(69,115,231,0.3);
                border-radius: 20px 20px 20px 20px;
                opacity: 1;
                img{
                    width: 22px;
                    height: 21px;
                    margin-top: 56px;
                }
            }
        }
        .box-card {
            margin-top: 88px;
            text-align: center;
            margin-bottom: 295px;
            .item {
                cursor: pointer;
                width: 650px;
                margin: 0 auto;
                text-align: left;
                padding-bottom: 61px;
                .hover-item{
                    padding-left: 50px;
                    background: rgba(238, 239, 245, 0.3);
                    border-radius: 26px 26px 26px 26px;
                    opacity: 1;
                    border: 3px solid #E4E4E6;
                    filter: blur(undefinedpx);
                }
                .hover-item:hover{
                    padding-left: 50px;
                    background: rgba(255, 255, 255, 0.3);
                    box-shadow: 0px 12px 60px 1px rgba(69,115,231,0.2);
                    border-radius: 26px 26px 26px 26px;
                    border: 3px solid #527CE9;
                }
                img {
                    margin-top: 60px;
                    width: 75px;
                    height: 69px;
                }
                .introT {
                    font-size: 32px;
                    font-weight: 600;
                    color: #1A1A2C;
                    line-height: 54px;
                    margin-top: 20px;
                    font-family: Poppins-SemiBold, Poppins;
                }
                .introD {
                    width: 564px;
                    font-size: 28px;
                    font-weight: 500;
                    color: #61666B;
                    font-family: Poppins-Medium, Poppins;
                    line-height: 46px;
                    margin-bottom: 62px;
                }
            }
        }
    }
</style>
